import { faPencil } from '@fortawesome/pro-light-svg-icons';
import { faArrowsRotate } from '@fortawesome/pro-regular-svg-icons/faArrowsRotate';
import { faMoneyBill } from '@fortawesome/pro-regular-svg-icons/faMoneyBill';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Membership } from '@spike/membership-model';
import clsx from 'clsx';
import { ToolbarButton, ToolbarItem } from 'components/UI';
import { FunctionComponent } from 'react';

export interface MembershipInfoProps {
    membership: Membership;
    disabled?: boolean;
    className?: string;
    onEdit: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flex: 1,
            width: '100%'
        },
        dataContainer: {
            dispaly: 'flex',
            flexDirection: 'column',
            maxWidth: '90%'
        },
        optionsContainer: {
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-end',
            alignItems: 'center'
        },
        namePriceContainer: {
            display: 'flex',
            alignItems: 'center'
        },
        name: {
            display: 'block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: 14,
            fontWeight: 500
        },
        price: {
            fontSize: 14,
            fontWeight: 500,
            whiteSpace: 'nowrap',
            paddingLeft: 5
        },
        type: {
            fontSize: 14,
            color: '#7A7A7A',
            textTransform: 'capitalize'
        },
        typeContainer: {
            display: 'flex',
            marginTop: 2,
            alignItems: 'center'
        },
        icon: {
            marginRight: 10
        }
    })
);

export const MembershipInfo: FunctionComponent<MembershipInfoProps> = props => {
    const classes = useStyles(props);

    return (
        <Box className={clsx(classes.container, props.className)}>
            <Box className={classes.dataContainer}>
                <Box className={classes.namePriceContainer}>
                    <Typography className={classes.name}>{props.membership.name}</Typography>
                    <Typography className={classes.price}>{`· $${Number(props.membership.total ?? 0).toFixed(
                        2
                    )}`}</Typography>
                </Box>
                <Box className={classes.typeContainer}>
                    <FontAwesomeIcon
                        icon={props.membership.enrollmentType === 'package' ? faMoneyBill : faArrowsRotate}
                        className={classes.icon}
                    />
                    <Typography className={classes.type}>{`${props.membership.enrollmentType}${
                        props.membership.billingFrequency ?? '' !== '' ? ' - ' : ''
                    }${props.membership.billingFrequency ?? ''}`}</Typography>
                </Box>
            </Box>
            <Box className={classes.optionsContainer}>
                <ToolbarButton disabled={props.disabled}>
                    <ToolbarItem
                        icon={faPencil}
                        onClick={props.onEdit}
                        text="Edit Membership"
                    />
                </ToolbarButton>
            </Box>
        </Box>
    );
};

export default MembershipInfo;
